import { useWindowWidth } from '@elfsight/widget-utils';
import { NARROW_BREAKPOINT } from '../../../common';

export function useCheckoutNarrowness() {
  const windowWidth = useWindowWidth();
  const isNarrow = windowWidth < NARROW_BREAKPOINT;

  return isNarrow;
}
